/* eslint-disable react/jsx-wrap-multilines */
import { Snackbar as MuiSnackbar, Slide, makeStyles } from '@material-ui/core';
import { Alert, Color } from '@material-ui/lab';
import React, { useEffect, useState } from 'react';
import { ReactComponent as SuccessIcon } from '../../assets/icons/sb-success.svg';
import { ReactComponent as ErrorIcon } from '../../assets/icons/sb-error.svg';
import { ReactComponent as CloseButton } from '../../assets/icons/close-button.svg';
import styles from './snackbar.module.css';

const Snackbar = ({
  visible,
  message,
  type = 'success' as Color,
  handleClose,
}: {
  visible: boolean;
  message: string | undefined;
  type: Color | undefined;
  handleClose: any;
}) => {
  const toastConfigs: Record<Color, any> = {
    success: {
      messageTitle: 'Success',
      color: '#4BC593',
    },
    error: {
      messageTitle: 'Error',
      color: '#F95849',
    },
    info: {
      messageTitle: 'Info',
      color: '#F95849',
    },
    warning: {
      messageTitle: 'Warning',
      color: '#F95849',
    },
  };
  const useStyles = makeStyles({
    root: {
      // width: '100%',
      borderLeft: '0.5em solid',
      borderColor: toastConfigs[type]?.color,
      boxShadow: '-1px 5px 8px rgba(0, 0, 0, 0.06)',
    },
    icon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    action: {
      display: 'flex',
      alignItems: 'start',
      justifyContent: 'center',
    },
    standardSuccess: {
      backgroundColor: '#FFFFFF',
      color: '#000000',
    },
    standardError: {
      backgroundColor: '#FFFFFF',
      color: '#000000',
    },
  });
  const classes = useStyles();
  const [isToastVisible, setIsToastVisible] = useState<boolean>(false);

  useEffect(() => {
    setIsToastVisible(visible);
  }, [visible]);

  return (
    <MuiSnackbar
      anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
      autoHideDuration={3000}
      open={isToastVisible}
      onClose={handleClose}
      TransitionComponent={Slide}
      className="lg:w-full"
    >
      <Alert
        classes={classes}
        className="w-full lg:w-2/6"
        variant="standard"
        iconMapping={{ success: <SuccessIcon />, error: <ErrorIcon /> }}
        action={
          <button aria-label="Close alert" type="button">
            <CloseButton onClick={handleClose} />
          </button>
        }
        severity={type}
      >
        <div className={styles['alert-msg']}>
          <div className={styles['alert-title']}>
            {toastConfigs[type]?.messageTitle}
          </div>
          <div className={styles['alert-detail']}>{message}</div>
        </div>
      </Alert>
    </MuiSnackbar>
  );
};

export default Snackbar;
